import { LineItemSsp } from '../apis/graphql';
import type { BillableThirdParty, DisplayEnum, PacingType } from '../configs';
import { pacingTypes } from '../configs';
import type { Nullable } from '../models';

export const US_COUNTRY_CODE = 'US';

export const DRAX_NULL_BILLABLE_THIRD_PARTY_BUFFER_TOOLTIP =
  'Automated buffers require a billable third party for DRAX lines.';

/**
 * `true` when every targeted country on a line item is the US country code.
 *
 * Empty / `null` / `undefined` `countries` returns `false`, mirroring the
 * legacy single-country behavior where a missing country also disabled
 * US-only features (e.g. Buffer Opt-In). A `null` or `undefined` entry inside
 * the array also yields `false` (we don't treat unknowns as US).
 */
export const isAllUS = (countries?: ReadonlyArray<string | null | undefined> | null): boolean =>
  !!countries && countries.length > 0 && countries.every((c) => c === US_COUNTRY_CODE);

type ShouldDisableBufferOptInArgs = {
  pacingType?: Nullable<DisplayEnum<PacingType>>;
  ssp?: Nullable<LineItemSsp>;
  billableThirdParty?: Nullable<DisplayEnum<BillableThirdParty>>;
};

/** Disables buffer opt-in when pacing is SOV or DRAX has no billable third party. */
export const shouldDisableBufferOptIn = ({
  pacingType,
  ssp,
  billableThirdParty,
}: ShouldDisableBufferOptInArgs): boolean =>
  pacingType?.key === pacingTypes.SOV.key || (ssp === LineItemSsp.Drax && billableThirdParty === null);

type GetDraxNullBillableThirdPartyBufferTooltipArgs = {
  ssp?: Nullable<LineItemSsp>;
  billableThirdParty?: Nullable<DisplayEnum<BillableThirdParty>>;
};

export const getDraxNullBillableThirdPartyBufferTooltip = ({
  ssp,
  billableThirdParty,
}: GetDraxNullBillableThirdPartyBufferTooltipArgs): string | undefined =>
  ssp === LineItemSsp.Drax && billableThirdParty === null ? DRAX_NULL_BILLABLE_THIRD_PARTY_BUFFER_TOOLTIP : undefined;
